<template>
	<ion-page>
		<spot-header :title="pageTitle" :canGoHome="true" :showLogo="false" @pressedGoHome="tryExit"></spot-header>
		<ion-content :fullscreen="true">
			<ion-item v-if="!isActive">
				<ion-spinner name="lines" color="primary"></ion-spinner>
				<ion-label color="primary">{{ spinnerText}}</ion-label>
			</ion-item>
			<div id="actionArea" v-if="isActive">
				<div class="movement-code-area" v-if="currentRec"> <!--v-if="isActive"-->
					<span class="movement-code">{{ currentRec.code }}</span>
				</div>
				<div id="fieldsContainer" class="content-rows"> <!--v-if="isActive"-->
					<web-socket-barcode @scanned="onScan"></web-socket-barcode>
					<div v-if="currField.id == field.review" class="review-items">
						<span v-if="currField.required">*</span>
						<ion-item slot="start" lines="full" v-for="element in reviewFields.list" :key="element.id">
							<ion-label v-if="element.type=='text'">{{ element.text }}</ion-label>
							<ion-input v-if="element.type=='text' && element.value" type="text" readonly v-model="element.value"></ion-input>
							<ion-label v-if="element.type=='image'" position="fixed">{{ element.text }}</ion-label>
							<ion-thumbnail v-if="element.type=='image' && element.value"><img :src="element.value" /></ion-thumbnail>
						</ion-item>
						<ion-item slot="start" lines="full" class="hidden" v-for="element in reviewFields.extra" :key="element.id">
							<ion-label v-if="element.type=='text'">{{ element.text }}</ion-label>
							<ion-input v-if="element.type=='text' && element.value" type="text" readonly v-model="element.value"></ion-input>
							<ion-label v-if="element.type=='image'" position="fixed">{{ element.text }}</ion-label>
							<ion-thumbnail v-if="element.type=='image' && element.value"><img :src="element.value" /></ion-thumbnail>
						</ion-item>
					</div>
					<div v-if="currField.id == field.signature">
						<div class="items-label">
							<ion-label>{{ currField.text }}</ion-label>
							<span v-if="currField.required">*</span>
						</div>
						<div class="items-data">
							<signature v-if="!isClosed" @saved="assignSignature" @removed="clearSignature"></signature>
							<ion-button fill="clear" :disabled="!currField.canAddItem" v-if="isVisibleButton(currField.canAddItem) && !isClosed" @click="addItem(currField.refTable)">
								<ion-icon slot="icon-only" :icon="addCircleOutline" size="large"></ion-icon>
							</ion-button>
						</div>
					</div>
					<div v-if="currField.id == field.waiting_for_proforma">
						<div class="items-label">
							<ion-label>{{ currField.text }}</ion-label>
							<span v-if="currField.required">*</span>
						</div>
						<div class="items-data">
							<ion-checkbox slot="start" v-model="currField.value" :placeholder="getPlaceHolder()" :disabled="isClosed"></ion-checkbox>
							<ion-button fill="clear" :disabled="!currField.canAddItem" v-if="isVisibleButton(currField.canAddItem) && !isClosed" @click="addItem()">
								<ion-icon slot="icon-only" :icon="addCircleOutline" size="large"></ion-icon>
							</ion-button>
						</div>
					</div>
					<div v-if="currField.id == field.tracking_number">
						<spot-input
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:type="currField.inputType"
							:clearInput="true"
							:canUnlock="currField.canUnlock"
							@textChanged="changedInput"
							@committed="committedInput">
						</spot-input>
					</div>
					<div v-if="currField.id == field.carrier_name">
						<spot-input
							:ref="currField.name"
							:label="currField.text"
							:allignLabel="currField.allignLabel"
							:required="currField.required"
							:placeholder="getPlaceHolder()"
							:enabled="!isClosed"
							:value="currField.value"
							:type="currField.inputType"
							:clearInput="true"
							:canUnlock="currField.canUnlock"
							@textChanged="changedInput"
							@committed="committedInput">
						</spot-input>
					</div>
				</div>
				<div id="actionsContainer"> <!--v-if="isActive"-->
					<spot-button
						v-if="isVisibleButton(currField.canGoBack)"
						fill="clear"
						size="large"
						color="primary"
						icon="chevronBackCircleOutline"
						:enabled="currField.canGoBack"
						:expand="null"
						:text=null
						@clicked="goBack()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canSkip)"
						fill="clear"
						size="large"
						color="primary"
						icon="playSkipForwardCircleOutline"
						:enabled="!isEmptyRequiredFields()"
						:expand="null"
						:text=null
						@clicked="goToSave()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canSave && !isClosed)"
						:fill="(showActionButtonsText) ? 'outline' : 'clear'"
						size="small"
						color="primary"
						icon="save"
						:enabled="!isEmptyRequiredFields()"
						:expand="null"
						:text="(showActionButtonsText) ? labelSave : null"
						@clicked="updateRecord()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canModify)"
						fill="outline"
						size="small"
						color="primary"
						icon="documentTextOutline"
						:enabled="!isDisableButton(currField.canModify)"
						:expand="null"
						:text="isClosed ? labelView : labelModify"
						@clicked="modifyRecord()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canReOpen && isClosed)"
						fill="outline"
						size="small"
						color="primary"
						icon="folderOpenOutline"
						:enabled="true"
						:expand="null"
						:text="labelReOpen"
						@clicked="openClosedMovement()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canPickUp && !isClosed)"
						fill="outline"
						size="small"
						color="primary"
						icon="downloadOutline"
						:enabled="!isDisableButton(currField.canPickUp)"
						:expand="null"
						:text="labelDelivery"
						@clicked="goAhead()">
					</spot-button>
					<spot-button
						v-if="isVisibleButton(currField.canGoAhead)"
						fill="clear"
						size="large"
						color="primary"
						icon="chevronForwardCircleOutline"
						:enabled="!isDisableButton(currField.canGoAhead)"
						:expand="null"
						:text=null
						@clicked="goAhead()">
					</spot-button>
				</div>
			</div>
			<div id="debugArea" style="color:red;" v-if="settings.global.debug">
				<div>Test Area</div>
				Current Field: {{ currField }}<br>
				<div v-for="element in fields.list" :key="element.id">
					{{ element.name }} = {{ element.value }}
				</div>
			</div>
		</ion-content>
	</ion-page>
</template>

<style scoped>
	ion-label {
		font-weight:bold;
	}
	.content-rows {
		display: flex;
		flex-direction: column;
		flex-wrap: wrap;
		/*justify-content: space-around;*/
		/*align-content: flex-start;*/
		/*padding: 1em;*/
		/*height: 10%;*/
		/*overflow: auto;*/
	}
	.hidden {
		--ion-background-color:lightgray;
	}
	.items-label {
		margin-top: .5em;
		margin-left: 1em;
	}
	.items-data {
		display: flex; /*inline-block;*/
		flex-direction: row;
		vertical-align: baseline;
		justify-content: space-between;
		text-align: left;
		margin-left: .5em;
		margin-right: .5em;
	}
	.movement-code-area {
		text-align: center;
		margin-top: .5em;
	}
	.movement-code {
		background: var(--ion-color-secondary);
		font-weight: bold;
	}
	ion-checkbox {
		margin-top: .5em;
		margin-left: .5em;
	}
	.review-items ion-item {
		--min-height: 0px;
	}
	.review-items ion-input {
		--padding-top: .5vh;
		--padding-bottom: .5vh;
	}
	.review-items :is(ion-label, ion-thumbnail) {
		margin-top: .5vh;
		margin-bottom: .5vh;
	}
</style>

<script>
	import WebSocketBarcode from "@/components/WebSocketBarcode.vue";
	import { IonButton, IonCheckbox, IonContent, IonIcon, IonInput, IonItem, IonLabel, IonPage, IonSpinner, IonThumbnail } from "@ionic/vue";
	import { addCircleOutline, chevronBackCircleOutline, chevronForwardCircleOutline, documentTextOutline, downloadOutline, folderOpenOutline, playSkipForwardCircleOutline, save } from "ionicons/icons";
	import { defineComponent } from "vue";
	import Signature from "../components/Signature.vue";
	import SpotButton from "../components/SpotButton.vue";
	import SpotHeader from "../components/SpotHeader.vue";
	import SpotInput from "../components/SpotInput.vue";
	import { confirmYesNo, showMsgInfo, showMsgWarning } from "../plugins/common.js";
	import { settings } from "../plugins/settings.js";
	import { getProject, getProjectRow, jsonSearchProjectRows, tablesData, updateProjectBulk, updateProjectFormDataBulk, updateProjectRow, updateProjectRowFormData } from '../plugins/customDatabase.js';
	import { backendUrl } from "../plugins/variables.js";

	export default defineComponent({
		name: "FinalizeShipment",
		props: {
			pageTitle: { type: String, default: "Concludi Spedizione" },
			defaultSpinnerText: { type: String, default: "Caricamento..." },
			loadingProjectText: { type: String, default: "Caricamento Testata..." },
			loadingProjectRowText: { type: String, default: "Caricamento Dettaglio..." },
			exitConfirmTitle: { type: String, default: "Conferma Uscita" },
			exitConfirmMessage: { type: String, default: "Confermi l'uscita dalla maschera di inserimento, annullando eventuali dati inseriti (i dati andranno persi)?" },
			labelSave: { type: String, default: "Salva" },
			labelView: { type: String, default: "Visualizza" },
			labelModify: { type: String, default: "Modifica" },
			labelDelivery: { type: String, default: "Consegna" },
			labelReOpen: { type: String, default: "Sblocca" },
			messageTitle: { type: String, default: "Chiusura Spedizione" },
			successUpdateMessage: { type: String, default: "Spedizione avvenuta correttamente" },
			warningUpdateNoRowMessage: { type: String, default: "Non ci sono articoli da spedire" },
			warningUpdateMessage: { type: String, default: "ATTENZIONE! Alcuni articoli non sono stati aggiornati" },
			reopenConfirmMessage: { type: String, default: "Confermi la riapertura della spedizione già chiusa?"},
			successMailMessage: { type: String, default: "Notificata spedizione via mail a: " },
			successMailMessages: { type: String, default: "Notificata spedizione via mail ai Mittenti " },
			unselected: { type: String, default: "Nessuno" },
		},
		components: {
			IonPage,
			IonItem,
			IonButton,
			IonIcon,
			IonContent,
			IonSpinner,
			IonLabel,
			IonInput,
			IonCheckbox,
			IonThumbnail,
			Signature,
			SpotHeader,
			SpotButton,
			SpotInput,
			WebSocketBarcode,
		},
		data: () => ({
			isActive: null,
			isClosed: null,
			sender: null,
			header_id: null,
			header_code: null,
			multipack: null,
			spinnerText: null,
			field: {
				review: 0,
				signature: 1,
				waiting_for_proforma: 2,
				tracking_number: 3,
				carrier_name: 4,
			},
			fields: {
				currentId: 0,
				list: [ //TODO: Nota che, in realtà canSkip, è poi uguale a NOT required (forse può essere rimosso), forse solo nel riepilogo è diverso, ma ci si può guardare
					{ id: 0, name: 'review', text: 'RIEPILOGO', allignLabel: false, placeholder: '', refTable: null, inputType: "readOnlyTexts", defaultValue: null, value: null, required: false, refField: null, canAddItem: false, canSkip: false, canGoBack: false, canGoAhead: false, canSave: false, canModify: false, canReOpen: false, canPickUp: true, canRefresh: false, canUnlock: false },
					{ id: 1, name: 'signature', text: 'Firma', allignLabel: false, placeholder: 'Firma Documento', refTable: null, inputType: "button", defaultValue: null, value: null, required: true, refField: null, canAddItem: false/*true*/, canSkip: true, canGoBack: false, canGoAhead: true, canSave: false, canModify: false, canReOpen: false, canPickUp: false, canRefresh: false, canUnlock: false },
					{ id: 2, name: 'waiting_for_proforma', text: 'Attendi Pro forma', allignLabel: false, placeholder: '', refTable: null, inputType: "check", defaultValue: null/*false*/, value: null/*false*/, required: false, refField: null, canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canModify: false, canReOpen: false, canPickUp: false, canRefresh: false, canUnlock: false },
					{ id: 3, name: 'tracking_number', text: 'Track ID', allignLabel: false, placeholder: 'Inserisci ID Spedizione', refTable: null, inputType: "text", defaultValue: null, value: null, required: false, refField: null, canAddItem: false, canSkip: true, canGoBack: true, canGoAhead: true, canSave: false, canModify: false, canReOpen: false, canPickUp: false, canRefresh: false, canUnlock: false },
					{ id: 4, name: 'carrier_name', text: 'Cognome Corriere', placeholder: 'Inserisci Nome e Cognome Corriere', refTable: null, inputType: "text", defaultValue: null, value: null, required: false, refField: null, canAddItem: false, canSkip: false, canGoBack: true, canGoAhead: false, canSave: true, canModify: false, canReOpen: false, canPickUp: false, canRefresh: false, canUnlock: false },
				],
			},
			reviewField: {
				list: {
					employee: 0,
					addressee: 1,
					carrier: 2,
					item: 3,
					pictures: 4,
					waiting_for_proforma: 5,
					urgent: 6,
					note: 7,
				},
				extra: {
					signature: 0,
					tracking_number: 1,
					carrier_name: 2,
				},
			},
			reviewFields: {
				list: [
					{ id: 0, name: 'employee', text: 'Richiedente:', value: null, type: 'text' },
					{ id: 1, name: 'addressee', text: 'Destinatario:', value: null, type: 'text' },
					{ id: 2, name: 'carrier', text: 'Corriere:', value: null, type: 'text' },
					{ id: 3, name: 'item', text: 'Formato:', value: null, type: 'text' },
					{ id: 4, name: 'pictures', text: 'Immagine:', value: null, type: 'image' },
					{ id: 5, name: 'waiting_for_proforma', text: 'Attendi Pro forma:', value: null, type: 'text' },
					{ id: 6, name: 'urgent', text: 'Urgente:', value: null, type: 'text' },
					{ id: 7, name: 'note', text: 'Note:', value: null, type: 'text' },
				],
				extra: [
					{ id: 0, name: 'signature', text: 'Firma:', value: null, type: 'image' },
					{ id: 1, name: 'tracking_number', text: 'Track ID:', value: null, type: 'text' },
					{ id: 2, name: 'carrier_name', text: 'Cognome Corriere:', value: null, type: 'text' },
				],
			},
			currentRec: {},
			showActionButtonsText : true,
			hasChangedSignature : false,
			chevronBackCircleOutline,
			chevronForwardCircleOutline,
			playSkipForwardCircleOutline,
			addCircleOutline,
			save,
			documentTextOutline,
			downloadOutline,
			folderOpenOutline,
			settings,
			confirmYesNo,
			showMsgInfo,
			showMsgWarning,
			getProject,
			getProjectRow,
			jsonSearchProjectRows,
			tablesData,
			updateProjectBulk,
			updateProjectFormDataBulk,
			updateProjectRow,
			updateProjectRowFormData,
			backendUrl,
		}),
		computed: {
			currField() {
				return this.fields.list[this.fields.currentId]
			},
			allOpenedProjectRows() {
				return {
					q: {
						'project_id_eq': this.header_id,
						'closed_eq': false, //to show only not closed
					}
				}
			},
		},
		async ionViewWillEnter() {
			this.setDefault();
			await this.getAllTablesData();
			await this.getCurrentProjectRow();
			await this.getCurrentProject();
			this.isActive=true;
		},
		ionViewWillLeave() {
			document.activeElement?.blur();
			this.isActive=false;
		},
		methods: {
			//Settings
			tryExit() {
				if (!this.isClosed && this.currField.id != this.field.review) {
					this.confirmYesNo(this.exitConfirmTitle, this.exitConfirmMessage)
					.then((data) => {
						if (data == true) {
							if (!this.multipack) this.$router.push("/home");
							else this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
						}
					})
				}
				else {
					if (!this.multipack) this.$router.push("/home");
					else this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
				}
			},
			getPlaceHolder() {
				return ((this.settings.global.showFieldsPlaceholder) ? (this.currField.required ? this.currField.placeholder : this.unselected ) : '')
			},
			isDisableButton(ability) {
				if (this.settings.global.fieldsCheckOnButtons && ability) {
					return (this.currField.required && !this.currField.value) ? true : false
				}
				else {
					return !ability
				}
			},
			isEmptyRequiredFields() {
				let ret = false;
				this.fields.list.forEach(element => {if (element.required && !element.value) ret=true});
				return ret;
			},
			isVisibleButton(ability) {
				return (this.settings.global.hideUnneededButtons) ? ability : true
			},
			getEmployeeDepartment(srcObject) {
				let infoDepartment = "";
				if (srcObject.department)
					infoDepartment = " (" + srcObject.department.name + ")"
				else if (srcObject.seat)
					infoDepartment = " (" + srcObject.seat + ")"
				else if (srcObject.seat_code)
					infoDepartment = " (" + srcObject.seat_code + ")"
				return srcObject.name + " " + srcObject.surname + infoDepartment
			},
			//Database
			async getAllTablesData() {
				//Do Nothing
			},
			async getCurrentProjectRow() {
				if (this.$route.params.id) {
					this.spinnerText = this.loadingProjectRowText;
					await this.getProjectRow(this.$route.params.id);
					if (this.tablesData.currentProjectRow) {
						this.currentRec = this.tablesData.currentProjectRow;
						//this.reviewFields.list[this.reviewField.list.employee].value=(this.currentRec.employee) ? this.currentRec.employee.name + ' ' + this.currentRec.employee.surname + (!this.currentRec.employee.department ? "" : " (" + this.currentRec.employee.department.name + ")") : null;
						this.reviewFields.list[this.reviewField.list.employee].value=(this.currentRec.employee) ? this.getEmployeeDepartment(this.currentRec.employee) : null;
						this.reviewFields.list[this.reviewField.list.addressee].value=(this.currentRec.addressee) ? this.currentRec.addressee.name : null;
						this.reviewFields.list[this.reviewField.list.carrier].value=(this.currentRec.carrier) ? this.currentRec.carrier.name : null;
						this.reviewFields.list[this.reviewField.list.item].value=(this.currentRec.item) ? this.currentRec.item.code : null;
						this.reviewFields.list[this.reviewField.list.pictures].value=(this.currentRec.picture_urls) ? this.backendUrl + this.currentRec.picture_urls : null;
						this.reviewFields.list[this.reviewField.list.waiting_for_proforma].value=(this.currentRec.waiting_for_proforma) ? 'Si' : 'No';
						this.reviewFields.list[this.reviewField.list.urgent].value=(this.currentRec.urgent) ? 'Si' : 'No';
						this.reviewFields.list[this.reviewField.list.note].value=(this.currentRec.notes && this.currentRec.notes.body) ? this.currentRec.notes.body : null;
						this.isClosed=(this.currentRec.closed) ? true : false;
						this.reviewFields.extra[this.reviewField.extra.signature].value=(this.currentRec.signature_url) ? this.backendUrl + this.currentRec.signature_url : null;
						this.reviewFields.extra[this.reviewField.extra.tracking_number].value=(this.currentRec.tracking_number) ? this.currentRec.tracking_number : null;
						this.reviewFields.extra[this.reviewField.extra.carrier_name].value=(this.currentRec.description) ? this.currentRec.description : null;
						this.fields.list[this.field.waiting_for_proforma].value=(this.currentRec.waiting_for_proforma) ? this.currentRec.waiting_for_proforma : false;
						this.header_id=this.currentRec.project.id;
						this.header_code=this.currentRec.project.code;
					}
				}
				if (this.$route.query.header_id) this.header_id = parseInt(this.$route.query.header_id);
				if (this.$route.query.multipack) this.multipack = (this.$route.query.multipack === 'true');
			},
			async getCurrentProject() {
				if (this.$route.query.header_id) {
					this.spinnerText = this.loadingProjectText;
					await this.getProject(this.header_id);
					if (this.tablesData.currentProject) {
						this.isClosed=(this.tablesData.currentProject.closed) ? true : false;
						this.header_code = this.tablesData.currentProject.code;
						this.goAhead();
					}
				}
			},
			async searchOpenedProjectRows() {
				if (this.$route.query.header_id) {
					await this.searchRecords(this.allOpenedProjectRows);
				}
			},
			async searchRecords(currSearch) {
				this.tablesData.projectRows = [];
				await this.jsonSearchProjectRows(currSearch);
			},
			prepareUpdateProjectRow() {
				let myRecord = {
					project_row: {
						signature: (this.fields.list[this.field.signature].value) ? this.fields.list[this.field.signature].value.id : null,
						waiting_for_proforma: (this.fields.list[this.field.waiting_for_proforma].value) ? this.fields.list[this.field.waiting_for_proforma].value : false,
						tracking_number: (this.fields.list[this.field.tracking_number].value) ? this.fields.list[this.field.tracking_number].value : null,
						description: (this.fields.list[this.field.carrier_name].value) ? this.fields.list[this.field.carrier_name].value : null,
						closed: true,
					}
				};
				return myRecord;
			},
			prepareBulkUpdateProjectRowsInProject() {
				let myRecord = {
					fields: {
						signature: (this.fields.list[this.field.signature].value) ? this.fields.list[this.field.signature].value.id : null,
						waiting_for_proforma: (this.fields.list[this.field.waiting_for_proforma].value) ? this.fields.list[this.field.waiting_for_proforma].value : false,
						tracking_number: (this.fields.list[this.field.tracking_number].value) ? this.fields.list[this.field.tracking_number].value : null,
						description: (this.fields.list[this.field.carrier_name].value) ? this.fields.list[this.field.carrier_name].value : null,
						closed: true,
					}
				};
				return myRecord;
			},
			prepareUpdateProjectRow_FormData() {
				let myRecord = new FormData();
				if (this.hasChangedSignature) myRecord.append('project_rows[signature]', this.fields.list[this.field.signature].value);
				myRecord.append('project_rows[waiting_for_proforma]', (this.fields.list[this.field.waiting_for_proforma].value) ? this.fields.list[this.field.waiting_for_proforma].value : false);
				if (this.fields.list[this.field.tracking_number].value) myRecord.append('project_rows[tracking_number]', this.fields.list[this.field.tracking_number].value); else myRecord.append('project_rows[tracking_number]', '');
				if (this.fields.list[this.field.carrier_name].value) myRecord.append('project_rows[description]', this.fields.list[this.field.carrier_name].value); else myRecord.append('project_rows[description]', '');
				myRecord.append('project_rows[closed]', true);
				return myRecord;
			},
			prepareBulkUpdateProjectRowsInProject_FormData() {
				let myRecord = new FormData();
				if (this.hasChangedSignature) myRecord.append('project_rows[signature]', this.fields.list[this.field.signature].value);
				myRecord.append('project_rows[waiting_for_proforma]', (this.fields.list[this.field.waiting_for_proforma].value) ? this.fields.list[this.field.waiting_for_proforma].value : false);
				if (this.fields.list[this.field.tracking_number].value) myRecord.append('project_rows[tracking_number]', this.fields.list[this.field.tracking_number].value); else myRecord.append('project_rows[tracking_number]', '');
				if (this.fields.list[this.field.carrier_name].value) myRecord.append('project_rows[description]', this.fields.list[this.field.carrier_name].value); else myRecord.append('project_rows[description]', '');
				myRecord.append('project_rows[closed]', true);
				return myRecord;
			},
			prepareUpdateProjectRow_EmptyFinalize() {
				let myRecord = {
					project_row: {
						tracking_number: null,
						description: null,
						closed: false,
					}
				};
				return myRecord;
			},
			async updateRecord() {
				if (!this.$route.query.header_id) {
					if (!this.fields.list[this.field.signature].value) await this.updateRecordJson();
					else await this.updateRecordFormData();
				}
				else {
					if (!this.fields.list[this.field.signature].value) await this.updateBulkRecordsJson();
					else await this.updateAllRecordsFormData();
				}
			},
			async updateRecordJson() {
				this.tablesData.currentProjectRow = null;
				await this.updateProjectRow(this.$route.params.id, this.prepareUpdateProjectRow(), false)
				if (this.tablesData.currentProjectRow) {
					if (this.tablesData.currentProjectRow.employee) {
						this.sender = "<br><br>" + this.successMailMessage + "&nbsp" + this.tablesData.currentProjectRow.employee.name + "&nbsp" + this.tablesData.currentProjectRow.employee.surname;
					} else {
						this.sender = ""/*null*/;
					}
					this.showMsgInfo(this.messageTitle, this.successUpdateMessage + this.sender);
					if (!this.multipack) this.$router.push("/home");
					else this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
				}
			},
			async updateAllRecordsJson() {
				await this.searchOpenedProjectRows();
				if (this.tablesData.projectRows.length>0) {
					let state = true;
					for (const element of this.tablesData.projectRows) {
						if (await this.updateProjectRow(element.id, this.prepareUpdateProjectRow(), false) == false) {
							state = false;
						}
					}
					if (state==true) {
						this.showMsgInfo(this.messageTitle,this.successUpdateMessage + "<br><br>" + this.successMailMessages);
					}
				}
				else {
					this.showMsgWarning(this.messageTitle,this.warningUpdateNoRowMessage);
				}
				this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
			},
			async updateBulkRecordsJson() {
				await this.searchOpenedProjectRows();
				if (this.tablesData.projectRows.length>0) {
					if (await this.updateProjectBulk(this.header_id, this.prepareBulkUpdateProjectRowsInProject(), false) == this.tablesData.projectRows.length) {
						this.showMsgInfo(this.messageTitle,this.successUpdateMessage + "<br><br>" + this.successMailMessages);
					} else {
						this.showMsgWarning(this.messageTitle,this.warningUpdateMessage);
					}
				}
				else {
					this.showMsgWarning(this.messageTitle,this.warningUpdateNoRowMessage);
				}
				this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
			},
			async updateRecordFormData() {
				this.tablesData.currentProjectRow = null;
				await this.updateProjectRowFormData(this.$route.params.id, this.prepareUpdateProjectRow_FormData(), false)
				if (this.tablesData.currentProjectRow) {
					if (this.tablesData.currentProjectRow.employee) {
						this.sender = "<br><br>" + this.successMailMessage + "&nbsp" + this.tablesData.currentProjectRow.employee.name + "&nbsp" + this.tablesData.currentProjectRow.employee.surname;
					} else {
						this.sender = ""/*null*/;
					}
					this.showMsgInfo(this.messageTitle, this.successUpdateMessage + this.sender);
					if (!this.multipack) this.$router.push("/home");
					else this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
				}
			},
			async updateAllRecordsFormData() {
				await this.searchOpenedProjectRows();
				if (this.tablesData.projectRows.length>0) {
					let state = true;
					for (const element of this.tablesData.projectRows) {
						if (await this.updateProjectRowFormData(element.id, this.prepareUpdateProjectRow_FormData(), false) == false) {
							state = false;
						}
					}
					if (state==true) {
						this.showMsgInfo(this.messageTitle,this.successUpdateMessage + "<br><br>" + this.successMailMessages);
					}
				}
				else {
					this.showMsgWarning(this.messageTitle,this.warningUpdateNoRowMessage);
				}
				this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
			},
			async updateBulkRecordsFormData() {
				await this.searchOpenedProjectRows();
				if (this.tablesData.projectRows.length>0) {
					if (await this.updateProjectFormDataBulk(this.header_id, this.prepareBulkUpdateProjectRowsInProject_FormData(), false) == this.tablesData.projectRows.length) {
						this.showMsgInfo(this.messageTitle,this.successUpdateMessage + "<br><br>" + this.successMailMessages);
					} else {
						this.showMsgWarning(this.messageTitle,this.warningUpdateMessage);
					}
				}
				else {
					this.showMsgWarning(this.messageTitle,this.warningUpdateNoRowMessage);
				}
				this.$router.push(`/revision/multiple/` + this.header_id + `?code=` + this.header_code);
			},
			async openClosedMovement() {
				let fieldValue = false;
				await this.confirmYesNo(this.messageTitle, this.reopenConfirmMessage)
				.then((data) => { if (data) { fieldValue = data } })
				if (fieldValue == true) {
					if (await this.updateProjectRow(this.$route.params.id, this.prepareUpdateProjectRow_EmptyFinalize(), false) == true) {
						await this.getCurrentProjectRow();
					}
				}
			},
			//Actions
			onScan(barcode) {
				if(this.isActive == true) {
					switch (this.currField.id) {
						case this.field.tracking_number:
							this.currField.value = barcode
							this.committedInput()
							break;
						default:
							// this.showMsgWarning("Barcode","non è ammessa la lettura di barcode")
					}
				}
			},
			setDefault() {
				this.spinnerText = this.defaultSpinnerText;
				this.fields.currentId = 0;
				this.fields.list.forEach(element => element.value = element.defaultValue);
				this.multipack = false;
				this.header_id = null;
				this.header_code = null;
				this.isClosed = false;
				this.hasChangedSignature = false;
				this.enableChangesOnProjectRows();
			},
			enableChangesOnProjectRows() {
				this.fields.list[this.field.review].canModify = !this.settings.finalizeShipment.disableChangeOnProjectRow;
				this.fields.list[this.field.review].canReOpen = !this.settings.finalizeShipment.disableChangeOnProjectRow;
			},
			modifyRecord() {
				this.$router.push(`/insert/shipment/${this.$route.params.id}`+ (this.multipack ? `?multipack=true` : ``));
			},
			detectReturn(keyCode) {
				if (keyCode == 13) setTimeout(() => this.goAhead(), 0);
			},
			changedInput(value) {
				this.currField.value = value;
			},
			committedInput() {
				setTimeout(() => this.goAhead(), 0);
			},
			goBack() {
				if (!this.$route.query.header_id) {
					if (this.fields.currentId >= this.field.review ) this.fields.currentId-=1;
				}
				else {
					if (this.fields.currentId > this.field.waiting_for_proforma ) this.fields.currentId-=1;
				}
			},
			goAhead() {
				if (this.fields.currentId <= (this.fields.list.length-1) ) this.fields.currentId+=1
				else this.executeLastFieldAction()
			},
			goToSave() {
				if (this.fields.currentId >= 0 && this.fields.currentId <= (this.fields.list.length-1) ) this.fields.currentId=this.fields.list.length-1
			},
			assignSignature(file) {
				this.hasChangedSignature = true;
				this.currField.value = file;
			},
			clearSignature() {
				this.currField.value = null;
			},
			executeLastFieldAction() {
				//TODO: Da Implementare (vedi quello della Insert, ma forse non serve perchè potrei abilitare solo il pulsante di salvataggio)
			},
			addItem(tableName) {
				if (tableName) {
				//TODO: Possibilmente implementa la funzionalità generica AddItem
				}
			},
		},
	});
</script>